import React from 'react';
import PropTypes from 'prop-types';
import TextField from './form-text-field';

export default function FormTextAreaField(props) {
  const {controlProps, ...rest} = props;
  const modifiedControlProps = Object.assign(
    {
      as: 'textarea',
    },
    controlProps,
  );

  return <TextField controlProps={modifiedControlProps} {...rest} />;
}

FormTextAreaField.propTypes = {
  /** Additional props to pass to the FormControl. */
  controlProps: PropTypes.object,
};
